export default __webpack_public_path__ + "static/media/exhibition_b.2ac38384.png";